import Banner from "../../images/banner.jpg";
import "./Privacy.css";
import Footer from "../Footer/Footer";
import NavBar from "../Layout/NavBar";

const Privacy = () => {
  const year = new Date().getFullYear();

  return (
    <div className="privacy-home">
      {/* Banner */}
      <div className="privacy-banner">
        <img src={Banner} alt="Flickerbound Banner" />
      </div>

      <NavBar />

      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="updated-date">Last updated: {year}</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Flickerbound (“we”, “our”, “us”) is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, and
            safeguard your information when you visit our website
            <strong> https://flickerbound.com</strong> or interact with our
            services.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>

          <h3>1. Information You Provide</h3>
          <p>
            We may collect personal information that you voluntarily provide,
            including:
          </p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Order details</li>
            <li>Messages sent through contact forms</li>
          </ul>

          <h3>2. Automatically Collected Information</h3>
          <p>
            When you browse our site, we may automatically collect certain
            information, such as:
          </p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Pages visited</li>
            <li>Time spent on the site</li>
          </ul>

          <h3>3. Payment Information</h3>
          <p>
            Payments are processed securely through third‑party providers (such
            as Stripe or PayPal). We do <strong>not</strong> store your credit
            card details.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use collected information to:</p>
          <ul>
            <li>Process and fulfill orders</li>
            <li>Improve website performance and user experience</li>
            <li>Respond to customer inquiries</li>
            <li>Personalize content and recommendations</li>
            <li>Maintain security and prevent fraud</li>
            <li>Analyze traffic and usage patterns</li>
          </ul>
          <p>
            We do <strong>not</strong> sell or rent your personal information to
            third parties.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            We use cookies to enhance your browsing experience, remember your
            preferences, and analyze site usage. You may disable cookies in your
            browser settings, but some features may not function properly.
          </p>
        </section>

        <section>
          <h2>Third‑Party Services</h2>
          <p>
            We may use third‑party tools for analytics, payment processing,
            advertising, or social media integration. These services may collect
            data according to their own privacy policies.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            We implement industry‑standard security measures to protect your
            information. However, no online service is completely secure, and we
            cannot guarantee absolute protection.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You may have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request corrections to inaccurate information</li>
            <li>Request deletion of your data</li>
            <li>Opt out of marketing communications</li>
          </ul>
          <p>
            To make a request, contact us at{" "}
            <strong>support@flickerbound.com</strong>.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. The “Last updated”
            date will always reflect the most recent version.
          </p>
        </section>

        <section>
            <h2>Contact Us</h2>
            <p>
                If you have questions about this Privacy Policy, you can reach us at:
            </p>
            <p>
                You may contact us through our website’s Contact page:
            </p>
            <p>
                <strong>https://flickerbound.com/contact</strong>
            </p>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default Privacy;
